import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import CompanyStore from 'stores/CompanyStore/store';
import { Roles } from 'constants/AdminConstants';
import useCoachKnockFeed from 'hooks/useCoachKnockFeed';
import { selectBannerItem, selectBellItems } from 'utils/KnockFeedUtils';
import toNumberOrNull from 'utils/NumberUtils';
import ProducerNudgeBanner from './ProducerNudgeBanner';
import ProducerKnockBell from './ProducerKnockBell';
/** Re-render cadence so bell items roll off while the page stays open. */
var ROLLOFF_TICK_MS = 60000;
/**
 * The producer in-app notification surface (launch requirement, locked
 * 2026-07-02): ONE Knock feed subscription feeding BOTH the persistent nudge
 * banner and the 8-hour-rolloff bell — a single component mount per page so we
 * never open two websockets for the same user. Mounts in the shared header
 * (player area / desktop web) and the mobile entry header (which the iOS shell
 * renders in its webview, so this same slice covers the phone).
 *
 * Producers only — coaches keep CoachKnockFeed. Dark-safe like the coach feed:
 * no items (or Knock unconfigured) → nothing renders.
 */
var ProducerKnockSurface = function (_a) {
    var _b, _c;
    var page = _a.page;
    var info = CompanyStore.getCompanyInfo();
    var userId = toNumberOrNull((_b = info === null || info === void 0 ? void 0 : info.current_user) === null || _b === void 0 ? void 0 : _b.id);
    var roleId = toNumberOrNull((_c = info === null || info === void 0 ? void 0 : info.current_user) === null || _c === void 0 ? void 0 : _c.role_id);
    var isSalesperson = roleId === Roles.SALESPERSON;
    var _d = useCoachKnockFeed(isSalesperson ? userId : null), items = _d.items, markInteracted = _d.markInteracted;
    var _e = useState(function () { return new Date(); }), now = _e[0], setNow = _e[1];
    // The rolloff tick only matters when this surface can render something —
    // the mobile header mounts this component for every user, and an
    // unconditional interval re-rendered a null component once a minute for
    // the whole session for coaches/admins.
    useEffect(function () {
        if (!isSalesperson) {
            return undefined;
        }
        var id = window.setInterval(function () { return setNow(new Date()); }, ROLLOFF_TICK_MS);
        return function () { return window.clearInterval(id); };
    }, [isSalesperson]);
    if (!isSalesperson) {
        return null;
    }
    var bannerItem = selectBannerItem(items, now);
    var bellItems = selectBellItems(items, now);
    // The tap means "I heard you" — Knock's interacted state is server-side, so
    // acknowledging here clears the banner on every surface (first-ack-wins).
    var acknowledge = function (item) { return markInteracted(item, { action: 'acknowledged' }); };
    return (_jsxs(_Fragment, { children: [_jsx(ProducerKnockBell, { items: bellItems, onAcknowledge: acknowledge, page: page }), bannerItem ? (_jsx(ProducerNudgeBanner, { item: bannerItem, onAcknowledge: function () { return acknowledge(bannerItem); } })) : null] }));
};
export default ProducerKnockSurface;
